import React from 'react';
import { Modal, ModalMobileLayout } from '@wix/design-system';
import { useProfileContext } from '@components/Contexts/ProfileContext';
import { ProfilePageType } from '@common/types';
import BriefContactStatusModalContentFail from '../BriefContactStatusModalContentFail';
import BriefContactStatusModalContentSuccess from '../BriefContactStatusModalContentSuccess';
import MyProjectsLink from '../MyProjectsLink';

const dataHooks = {
  modalMobileLayout: 'brief-contact-status-modal-mobile-layout',
};

type Props = {
  contactStatus: 'success' | 'error';
  clearStatus: () => void;
};

const BriefContactStatusModalMobile = ({
  contactStatus,
  clearStatus,
}: Props) => {
  const { profilePageType } = useProfileContext();

  const isSuccess = contactStatus === 'success';
  const showMyProjectsLink =
    isSuccess && profilePageType === ProfilePageType.MARKETPLACE;

  return (
    <Modal isOpen={true} screen="full" onRequestClose={clearStatus}>
      <ModalMobileLayout
        dataHook={dataHooks.modalMobileLayout}
        fullscreen
        content={
          isSuccess ? (
            <BriefContactStatusModalContentSuccess isMobile />
          ) : (
            <BriefContactStatusModalContentFail
              isMobile
              onClickTryAgain={clearStatus}
            />
          )
        }
        onCloseButtonClick={clearStatus}
        footer={showMyProjectsLink ? <MyProjectsLink /> : null}
      />
    </Modal>
  );
};

export default BriefContactStatusModalMobile;
